import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

export const completeService = createAsyncThunk(
	"completeService",
	async ({ assetId, serviceId, data }) => {
		const payload = {
			completionDate: data.completionDate?.toISOString
				? data.completionDate.toISOString()
				: data.completionDate,
			diagnosis: data.diagnosis,
			workDone: data.workDone,
			cost: data.cost,
		};

		// Route: POST /assets/:id/service/:serviceId/complete
		// Both assetId and serviceId are required in the URL.
		const response = await axiosHttp.post(
			`assets/${assetId}/service/${serviceId}/complete`,
			payload
		);
		message.success("Service record completed!");
		return response.data?.data;
	}
);

const ServiceCompleteSlice = createSlice({
	name: "serviceCompleteSlice",
	initialState: { isLoading: false, data: null, error: null },
	extraReducers: (builder) => {
		builder.addCase(completeService.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(completeService.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(completeService.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.error;
			message.error(action.error?.message || "Failed to complete service record");
		});
	},
});

export default ServiceCompleteSlice.reducer;
